import _ from 'lodash'

export const mergeUnique = (records=[], payload=[], field='id') => {
  return payload.reduce((previous, current) => {
    const i = previous.findIndex(item => item[field] === current[field])
    if (i === -1) {
      return [ ...previous, current ]
    } else {
      return previous
    }
  }, records || [])
}


export const mergeUniqueReverse = (records=[], payload=[], field='id') => {
  const result = records.reduce((previous, current) => {
    const i = previous.findIndex(item => item[field] === current[field])
    if (i === -1) {
      return [ current, ...previous ]
    } else {
      return previous
    }
  }, payload || [])
  return result
}


export const appendMessges = (records=[], payload=[], field='id') => {
  const result = records.reduce((previous, current) => {
    const i = previous.findIndex(item => item[field] === current[field])
    if (i === -1) {
      return [ current, ...previous ]
    } else {
      return previous
    }
  }, payload || [])
  return _.sortBy(result, field)
}

export const appendChatrooms = (chatrooms = {}, payload = {}) => {
  const current = payload?.result || []
  const page = payload?.metadata?.pagination.page || 1
  if (page === 1) {
    return current
  }

  const previous = chatrooms?.result || []
  return _.uniqBy([...previous, ...current], 'id')
}

export const appendF2FPerformers = (records = [], payload = {}, field = 'id') => {
  const page = payload?.pagination.page || 1
  if (page === 1) {
    return payload?.performers || []
  }
  return _.uniqBy([ ...records, ...payload?.performers || [] ], field)
}

export const appendF2FCallHistory = (records = [], payload = {}, field = 'id') => {
  const page = payload?.pagination.page || 1
  if (page === 1) {
    return payload?.callHistory || []
  }
  return _.uniqBy([ ...records, ...payload?.callHistory || [] ], field)
}

export const appendTransactionHistory = (records = [], payload = {}, field = 'id') => {
  const page = payload?.pagination.page || 1
  if (page === 1) {
    return payload?.transactionHistory || []
  }
  return _.uniqBy([ ...records, ...payload?.transactionHistory || [] ], field)
}
